export const SelectedMark = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <ellipse cx="10.5" cy="10.5" rx="10.5" ry="10.5" fill="white" />
      <path
        d="M10.5 0C8.4233 0 6.39323 0.615814 4.66652 1.76957C2.9398 2.92332 1.59399 4.5632 0.799269 6.48182C0.00454947 8.40045 -0.203385 10.5116 0.201759 12.5484C0.606904 14.5852 1.60693 16.4562 3.07538 17.9246C4.54383 19.3931 6.41476 20.3931 8.45156 20.7982C10.4884 21.2034 12.5996 20.9955 14.5182 20.2007C16.4368 19.406 18.0767 18.0602 19.2304 16.3335C20.3842 14.6068 21 12.5767 21 10.5C21 7.71522 19.8938 5.04451 17.9246 3.07538C15.9555 1.10625 13.2848 0 10.5 0ZM17.3578 6.97594L13.0463 11.2842L8.73469 15.5925L3.64219 10.5C3.46814 10.3259 3.37036 10.0899 3.37036 9.84375C3.37036 9.59761 3.46814 9.36155 3.64219 9.1875C3.81624 9.01345 4.0523 8.91567 4.29844 8.91567C4.54458 8.91567 4.78064 9.01345 4.95469 9.1875L8.74782 12.9806L16.0584 5.67656C16.1446 5.59038 16.2469 5.52202 16.3595 5.47538C16.4721 5.42874 16.5928 5.40473 16.7147 5.40473C16.8366 5.40473 16.9572 5.42874 17.0698 5.47538C17.1824 5.52202 17.2848 5.59038 17.3709 5.67656C17.4571 5.76274 17.5255 5.86505 17.5721 5.97765C17.6188 6.09025 17.6428 6.21093 17.6428 6.33281C17.6428 6.45469 17.6188 6.57537 17.5721 6.68797C17.5255 6.80057 17.4571 6.90288 17.3709 6.98906L17.3578 6.97594Z"
        fill="#8BC34A"
      />
    </svg>
  );
};
